import React from 'react';
import styled from 'styled-components';
import { useRebuttalsQuery } from '@queries/slides';
import { useClient } from '@context/presentation';
import { RebuttalsProvider } from '@context/rebuttals';
import { getErrorMessage } from '@utils/errorHandling';
import { RebuttalDropdown } from '@components';
import { REBUTTAL_TAGS } from '@constants';

const RebuttalList = styled.div`
    margin: 20px 0;
    >div {
      height: 100%;
      padding: 5px;
      margin-bottom: 0;
    }
`;

// Query for all rebuttals here
export const RebuttalsSection = ({ dispatch, slideId }) => {
    const { loanOffer } = useClient();
    const { error, loading, data } = useRebuttalsQuery();
    const { moreInformation, VCL, video, ficoAndCredit } = REBUTTAL_TAGS;

    if (loading) return <div>Loading rebuttals...</div>;

    if (error) return <div>Error loading rebuttal slides: {getErrorMessage(error)}</div>;

    return (
        <RebuttalsProvider
            slideId={slideId}
            rebuttals={data}
            dispatch={dispatch}>
                <RebuttalList>
                    <RebuttalDropdown rebuttalType={ficoAndCredit} />
                    <RebuttalDropdown rebuttalType={moreInformation} />
                    {
                        loanOffer?.VCL && <RebuttalDropdown rebuttalType={VCL} />
                    }
                    <RebuttalDropdown rebuttalType={video} />
                </RebuttalList>
        </RebuttalsProvider>
    );
};

export default RebuttalsSection;
